export default "__VITE_ASSET__DxZUx2kq__"